export default __webpack_public_path__ + "locales/ro/EmptyTrashDialog.json?hash=65ae87425298a35cdb9a9f53a1e8bc8e";